import React from 'react';

import Box from '@material-ui/core/Box';
import { Marker } from '@react-google-maps/api';
import MapComponent from 'components/Map/Map';
import Pickup from 'assets/img/map-icons/pickup.png';
import Dropoff from 'assets/img/map-icons/dropoff.png';
import MarkerWithLabel from 'components/Map/MarkerWithLabel';
import PropTypes from 'prop-types';

const TelemetryMap = ({ locations }) => {
  const getIcon = (icon) => {
    switch (icon) {
      case 'pickup':
        return Pickup;
      case 'dropoff':
        return Dropoff;
      default:
        return Pickup;
    }
  };

  return (
    <Box sx={{ p: 1 }}>
      <MapComponent
        zoom={14}
        defaultOptions={{
          draggable: false,
        }}
        center={{
          lat: locations[0].lat,
          lng: locations[0].lng,
        }}
        mapContainerStyle={{ height: 280, width: '100%' }}
      >
        {locations.map((location, index) => {
          return location.icon ? (
            <MarkerWithLabel
              zIndex={0}
              key={index}
              position={location}
              label={location?.name}
              icon={{ url: getIcon(location.icon) }}
              labelStyle={{
                textAlign: 'center',
                color: location.color,
                backgroundColor: 'rgba(255,255,255,0.8)',
                fontSize: 16,
                padding: 3,
              }}
            />
          ) : (
            <Marker key={index} position={location} />
          );
        })}
      </MapComponent>
    </Box>
  );
};
TelemetryMap.propTypes = {
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired,
      icon: PropTypes.string,
      name: PropTypes.string,
      color: PropTypes.string,
    })
  ).isRequired,
};

export default TelemetryMap;
